export const isImageGalleryBlockImageItem = (
  item: Content.Properties.ImageGalleryBlockItem,
): item is Content.Properties.ImageGalleryBlockImageItem => {
  return item.$type === 'ImageGalleryBlockImageItemDto';
};

export const isImageGalleryBlockYoutubeItem = (
  item: Content.Properties.ImageGalleryBlockItem,
): item is Content.Properties.ImageGalleryBlockYoutubeItem => {
  return item.$type === 'ImageGalleryBlockYoutubeItemDto';
};
